import { TriangleAlert } from 'lucide-react';
import { useMe } from '@/features/auth/hooks';

export function DevMockBadge() {
  const { data } = useMe();
  if (!data || !data.devMockActions) return null;

  return (
    <span
      role="status"
      aria-label="Modo mock ativo — ações de moderação não atingem plataformas reais"
      title="Ban, timeout, delete e broadcast simulados. Audit log marca mocked=1."
      className="inline-flex items-center gap-1 px-2 h-6 rounded-full border border-warning/30 bg-warning/10 text-warning text-xs font-medium uppercase tracking-wide"
    >
      <TriangleAlert size={12} strokeWidth={2} aria-hidden="true" />
      MOCK
    </span>
  );
}
